import { Button, Checkbox, Form, message, Modal, notification } from "antd";
import React, { useEffect, useState } from "react";
import axios from "axios";
import "./stylelogin.css";
import { Col, Row } from "react-bootstrap";
import Hande from "../../../images/Partner-logo.png";
import LoginPageHeading from "../../../common/UiLoginPageHeading/UiLoginPageHeading";
import TextInput from "../../../components/Common/UITextInput/TextInput";
import UiButton from "../../../common/UiButton/UiButton";
import useForm from "../../../common/hooks/useForm";
import { useNavigate } from "react-router-dom";
import moment from "moment";

import verfiedGreenIcon from "../../../images/verfied-green-icon.png";
import verfiedGrayIcon from "../../../images/verfied-gray-icon.png";
import passwordMatchIcon from "../../../images/password-match-icon.png";
import useWindowSize from "../../../utils/useWindowSize";
import { connect } from "react-redux";
import {
  isFirstTimeLogin,
  isForgotPassword,
  login,
  loginSuccess,
  optLogin,
  resendLoginOTP,
  resendOtp,
  setNewPassword,
  verifyOtp,
} from "../../../redux/Auth/authActions";
import BackArrow from "../../../images/back-arrow-green.png";
import forge from "node-forge";
import { useDispatch } from "react-redux";

const NewUserLogin = (props) => {
  const history = useNavigate();
  const [form] = Form.useForm();
  const FormItem = Form.Item;
  const { state, onChangeTextHandler, setState } = useForm();
  const [isPasswordFocused, setIsPasswordFocused] = useState(false);

  // Hide show
  const [mobileNumberOption, setMobileNumberOption] = useState(false);
  const [emailIdOption, setEmailIdOption] = useState(true);
  const [otpVerifiedScreen, setOtpVerifiedScreen] = useState(false);
  const [NewPasswordScreen, setNewPasswordScreen] = useState(false);
  const [showForgotPassword, setShowForgotPassword] = useState(false);
  const [passwordScreen, setPasswordScreen] = useState(false);
  const [maskedUsername, setMaskedUsername] = useState("");
  const [loginWith, setLoginWith] = useState("EMAIL");
  const [loggedInRoleType, setLoggedInRoleType] = useState("");
  const [isAlreadyLoggin, setIsAlreadyLoggin] = useState(false);
  const [ip, setIP] = useState("");
  const [btnDisable, setBtnDisable] = useState(false);
  const { width } = useWindowSize();

  const mobile = width < 786 ? true : false;

  // form timer show
  const [timer, setTimer] = useState(120);
  const [isTimerOn, setIsTimerOn] = useState(false);
  const [userLoginData, setUserLoginData] = useState(null);
  const [otpId, setOtpId] = useState(null);
  const [maskedUserEmail, setmaskedUserEmail] = useState(null);
  const [maskedUserMobile, setmaskedUserMobile] = useState(null);
  const dispatch = useDispatch();
  useEffect(() => {
    let interval = null;
    if (isTimerOn && timer > 0) {
      interval = setInterval(() => {
        setTimer((timer) => timer - 1);
      }, 1000);
    } else if (!isTimerOn && timer !== 0) {
      clearInterval(interval);
    }
    return () => clearInterval(interval);
  }, [isTimerOn, timer]);

  const isAlreadyLogginHandlerOk = () => {
    setOtpVerifiedScreen(false);
    setNewPasswordScreen(false);
    setEmailIdOption(false);
    setMobileNumberOption(false);
    setPasswordScreen(true);
    setIsAlreadyLoggin(false);
  };

  const handleBackToLoginScreen = () => {
    setUserLoginData(null);
    setState({
      ...state,
      password: "",
    });
    form.setFieldValue({
      password: "",
    });
    setOtpVerifiedScreen(false);
    setNewPasswordScreen(false);
    setEmailIdOption(true);
    setMobileNumberOption(false);
    setPasswordScreen(false);
    setIsAlreadyLoggin(false);
    setIsTimerOn(false);
    setTimer(120);
  };

  const isAlreadyLogginHandlerCancel = () => {
    setIsAlreadyLoggin(false);
  };

  const handleCheckBox = () => {
    setMobileNumberOption(!mobileNumberOption);
    setEmailIdOption(!emailIdOption);
    form.resetFields();
    setShowForgotPassword(false);
    setState({
      ...state,
      email: "",
      mobileNo: "",
      otp: "",
      password: "",
      confirm: "",
      username: "",
    });
  };

  window.onload = function () {
    clearCache();
  };

  function clearCache() {
    if ("caches" in window) {
      caches
        .keys()
        .then(function (keyList) {
          return Promise.all(
            keyList.map(function (key) {
              return caches.delete(key);
            })
          );
        })
        .then(function () {
          console.log("Cache cleared!");
        });
    }
  }

  const handleCheckIsFirstTimeLogin = async () => {
    let regx = /^(\+\d{1,3}[- ]?)?\d{10}$/;
    if (regx.exec(state.email)) {
      message.error("You can not login using phone number in emailId");
      // message.destroy();

      return;
    }
    setBtnDisable(true);
    message.destroy();
    message.loading("Loading please wait...", 0);

    setState({
      ...state,
      username: state.email?.trim() || state.mobileNo?.trim(),
    });
    try {
      const res = await props.isFirstTimeLogin({
        username: state.email?.trim() || state.mobileNo?.trim(),
      });
      if (res) {
        console.log("datares", res);
        clearCache();
        message.destroy();
        setBtnDisable(false);
        if (res && res.status === 200) {
          setMaskedUsername(res.data?.maskedUsername);
          setLoginWith(res.data?.dto?.loginWith);
          setLoggedInRoleType(res.data?.dto?.loggedInRoleType);

          if (res?.data?.dto?.firstTimeLogin === true) {
            setOtpVerifiedScreen(true);
            setNewPasswordScreen(false);
            setEmailIdOption(false);
            setMobileNumberOption(false);
            setIsTimerOn(true);
            if (res?.data?.dto?.message) {
              message.success(res?.data?.dto?.message);
            }
          } else if (
            !res.data?.dto?.firstTimeLogin &&
            res.data?.dto?.alreadyLoggedIn
          ) {
            setIsAlreadyLoggin(true);
          } else {
            setOtpVerifiedScreen(false);
            setNewPasswordScreen(false);
            setEmailIdOption(false);
            setMobileNumberOption(false);
            setPasswordScreen(true);
          }
        } else {
          clearCache();
          setShowForgotPassword(true);
        }

        if (res?.message) {
          clearCache();
          notification.error({
            description: res?.message,
            duration: 5,
            placement: "top",
          });
        }
      }
    } catch (error) {
      clearCache();
      setBtnDisable(false);
      message.destroy();
      message.error(error);
    }
  };
  const handleOptLogin = () => {
    let payloadObj = {
      access_token: userLoginData.data.dto?.accessToken?.access_token,
      userName: userLoginData.data.dto?.userName,
      otpId: otpId,
      otp: state.otp,
      transactionId: "1234",
    };
    setBtnDisable(true);
    message.destroy();
    message.loading("Loading please wait...", 0);
    props
      .optLogin(payloadObj)
      .then((res) => {
        message.destroy();
        setBtnDisable(false);
        if (res && res.status === 200) {
          dispatch(loginSuccess(userLoginData));
          setOtpVerifiedScreen(false);
          setNewPasswordScreen(true);
          setEmailIdOption(false);
          setMobileNumberOption(false);
          setPasswordScreen(false);
          setIsTimerOn(false);
          setTimer(120);
          onLoginSuccessNavigate(userLoginData);
        }
        if (res?.data?.error?.message || res.message) {
          notification.error({
            description: res?.data?.error?.message || res.message,
            duration: 5,
            placement: "top",
          });
        }
      })
      .catch((error) => {
        setBtnDisable(false);
        message.error(error);
        message.destroy();
      });
  };
  const handleOtpVerification = () => {
    if (state.otp.length === 4) {
      if (userLoginData !== null) {
        handleOptLogin();
        return;
      }
      setBtnDisable(true);
      message.destroy();
      message.loading("Loading please wait...", 0);
      props
        .verifyOtp({
          otp: state.otp,
          username: state.username,
        })
        .then((res) => {
          message.destroy();
          setBtnDisable(false);
          if (res && res.status === 200) {
            setOtpVerifiedScreen(false);
            setNewPasswordScreen(true);
            setEmailIdOption(false);
            setMobileNumberOption(false);
            setPasswordScreen(false);
            setIsTimerOn(false);
            message.success(
              "Your OTP has been verified successfully !! Please set a password for your next login"
            );
          }
          if (res?.data?.error?.message || res.message) {
            notification.error({
              description: res?.data?.error?.message || res.message,
              duration: 5,
              placement: "top",
            });
          }
        })
        .catch((error) => {
          setBtnDisable(false);
          message.error(error);
          message.destroy();
        });
    } else {
      message.error("Please enter valid OTP");
    }
  };

  const handleSetNewPasswordSubmit = () => {
    if (state.password === state.confirm) {
      setBtnDisable(true);
      message.destroy();
      message.loading("Please Wait...", 0);
      props
        .setNewPassword({
          password: state.password,
          VerifyOTPToken: props.auth?.VerifyOTPToken,
        })
        .then((res) => {
          setBtnDisable(false);
          message.destroy();
          if (res && res.status === 200) {
            // message.success("Logged Successful", 3);
            if (res.data?.dto?.loggedInRoleType === "CET") {
              history("/CETDashboard/PartnerManagement");
            } else if (res.data?.dto?.loggedInRoleType === "RM") {
              history("/RMDashboard/PartnerManagement");
            } else if (res.data?.dto?.loggedInRoleType === "PARTNER") {
              history("/leadManagementDashboard/Dashboard");
            } else if (res.data?.dto?.loggedInRoleType === "PLMU") {
              history("/leadManagementDashboard/Dashboard");
            }

            // else if (res.data?.dto?.loggedInRoleType === "PARTNER") {
            //   history("/PartnerDashboard/engagementDetails");
            // }
          }
          if (res?.data?.error?.message || res.message) {
            setBtnDisable(false);
            notification.error({
              description: res?.data?.error?.message || res.message,
              duration: 5,
              placement: "top",
            });
          }
        })
        .catch((error) => {
          setBtnDisable(false);
          message.destroy();
          message.error(error);
        });
    } else {
      message.error("Password does not match");
    }
  };

  function encryptPassword(password, publicKeyBase64) {
    try {
      if (!password) {
        throw new Error("Password is required");
      }
      if (!publicKeyBase64) {
        throw new Error("Base64 public key is required");
      }
      if (new TextEncoder().encode(password).length > 446) {
        throw new Error("Password too large for 4096-bit RSA (max 446 bytes)");
      }

      let publicKeyDer;
      try {
        publicKeyDer = forge.util.decode64(publicKeyBase64);
      } catch (error) {
        throw new Error("Invalid Base64 public key: " + error.message);
      }

      let publicKey;
      try {
        publicKey = forge.pki.publicKeyFromAsn1(
          forge.asn1.fromDer(forge.util.createBuffer(publicKeyDer))
        );
      } catch (error) {
        throw new Error("Failed to parse public key: " + error.message);
      }

      const md = forge.md.sha256.create();
      const mgf1 = forge.md.sha1.create();
      const encrypted = publicKey.encrypt(password, "RSA-OAEP", {
        md: md,
        mgf1: { md: mgf1 },
      });

      const encryptedBase64 = forge.util.encode64(encrypted);
      return encryptedBase64;
    } catch (error) {
      console.error("Encryption error:", error);
      throw new Error("Failed to encrypt password: " + error.message);
    }
  }

  const handleLogin = () => {
    const publicKeyBase64 = process.env.REACT_APP_ENCRYPTION_KEY;
    const encryptedPassword = encryptPassword(state.password, publicKeyBase64);

    const encryptedPayload = {
      ...state,
      password: encryptedPassword,
    };

    setBtnDisable(true);
    message.destroy();
    message.loading("Please Wait...", 0);
    props.userLogin({ state: encryptedPayload, history, ip }).then((res) => {
      console.log("ksbiksbdiksbduisduik", res);
      if (res) {
        clearCache();
        message.destroy();
        if (res && res.status === 200) {
          if (res?.data?.dto?.isMfa) {
            setUserLoginData(res);
            setOtpId(res?.data?.dto?.otpId);
            setmaskedUserEmail(res?.data?.dto?.maskedUserEmail);
            setmaskedUserMobile(res?.data?.dto?.maskedUserMobile);
            setOtpVerifiedScreen(true);
            setIsTimerOn(true);
            setTimer(120);
            setPasswordScreen(false);
          } else {
            dispatch(loginSuccess(res));
            setOtpVerifiedScreen(false);
            setNewPasswordScreen(true);
            setEmailIdOption(false);
            setMobileNumberOption(false);
            setPasswordScreen(false);
            setIsTimerOn(false);
            setTimer(120);
            onLoginSuccessNavigate(res);
          }
        }
        if (res?.data?.error?.message || res.message) {
          setBtnDisable(false);
          notification.error({
            description: res?.data?.error?.message || res.message,
            duration: 5,
            placement: "top",
          });
        }
      } else {
        clearCache();
        setBtnDisable(false);
        message.destroy();
        message.error("Internal Server Error", 2);
      }
    });
  };
  const onLoginSuccessNavigate = (res) => {
    setBtnDisable(false);
    clearCache();
    if (res.data?.dto?.loggedInRoleType === "CET") {
      history("/CETDashboard/PartnerManagement");
    } else if (res.data?.dto?.loggedInRoleType === "RM") {
      history("/RMDashboard/PartnerManagement");
    } else if (res.data?.dto?.loggedInRoleType === "PARTNER") {
      if (
        res.data?.partnerFirmDetails?.partnerFirmStatus ===
          "FOR_VERIFICATION" ||
        res.data?.partnerFirmDetails?.partnerFirmStatus === "ESIGN_PENDING" ||
        res.data?.partnerFirmDetails?.partnerFirmStatus === "APPROVED"
      ) {
        history("/leadManagementDashboard/Dashboard");
      } else {
        history("/leadManagementDashboard/Dashboard");
      }
    } else if (res.data?.dto?.loggedInRoleType === "PLMU") {
      if (
        res.data?.partnerFirmDetails?.partnerFirmStatus ===
          "FOR_VERIFICATION" ||
        res.data?.partnerFirmDetails?.partnerFirmStatus === "ESIGN_PENDING" ||
        res.data?.partnerFirmDetails?.partnerFirmStatus === "APPROVED"
      ) {
        history("/leadManagementDashboard/Dashboard");
      } else {
        history("/leadManagementDashboard/Dashboard");
      }
    } else if (res.data?.dto?.loggedInRoleType === "POU") {
      if (
        res.data?.partnerFirmDetails?.partnerFirmStatus ===
          "FOR_VERIFICATION" ||
        res.data?.partnerFirmDetails?.partnerFirmStatus === "ESIGN_PENDING" ||
        res.data?.partnerFirmDetails?.partnerFirmStatus === "APPROVED"
      ) {
        history("/leadManagementDashboard/Dashboard");
      } else {
        history("/leadManagementDashboard/Dashboard");
      }
    }
  };

  const handleForgotPassword = async () => {
    if (loggedInRoleType === "CET" || loggedInRoleType === "RM") {
      return message.success(
        "Please contact your admin to reset your password",
        4
      );
    }
    message.destroy();
    message.loading("Please Wait...", 0);
    try {
      const res = await props.isForgotPassword({
        username: state.username,
      });
      if (res) {
        message.destroy();
        if (res && res.status === 200) {
          setUserLoginData(null);
          setOtpVerifiedScreen(true);
          setPasswordScreen(false);
          setNewPasswordScreen(false);
          setEmailIdOption(false);
          setMobileNumberOption(false);
          setIsTimerOn(true);
          setTimer(120);

          message.success(res?.data?.dto?.message);
        }
        if (res?.data?.error?.message || res.message) {
          notification.error({
            description: res?.data?.error?.message || res.message,
            duration: 5,
            placement: "top",
          });
        }
      }
    } catch (error) {
      message.destroy();
      message.error("Internal Server Error", 2);
    }
  };
  const handleResendLoginOtp = () => {
    message.destroy();
    message.loading("Please Wait...", 0);
    let payloadObj = {
      access_token: userLoginData.data.dto?.accessToken?.access_token,
      payload: {
        userName: userLoginData.data.dto?.userName,
        userId: userLoginData.data.dto?.userId,
      },
    };
    props.resendLoginOTP(payloadObj).then((res) => {
      if (res) {
        message.destroy();
        if (res && res.status === 200) {
          message.success(
            <>
              OTP has sent on registered
              {maskedUserEmail && ` email ID (${maskedUserEmail}) `}
              {maskedUserEmail && maskedUserMobile && ` and`}
              {maskedUserMobile && ` mobile number (${maskedUserMobile}) `}
              to proceed.
            </>,
            3
          );
          setOtpId(res?.data?.otpId);
          setIsTimerOn(true);
          setTimer(120);
        }
        if (res?.data?.error?.message || res.message) {
          notification.error({
            description: res?.data?.error?.message || res.message,
            duration: 5,
            placement: "top",
          });
        }
      } else {
        message.destroy();
        message.error(res.data && res.data.error && res.data.error.message);
      }
    });
  };
  const handleResendOtp = () => {
    if (userLoginData !== null) {
      handleResendLoginOtp();
      return;
    }
    message.destroy();
    message.loading("Please Wait...", 0);
    props.resendOtp({ username: state.username }).then((res) => {
      if (res) {
        message.destroy();
        if (res && res.status === 200) {
          message.success(res?.data?.dto?.message, 3);
          setIsTimerOn(true);
          setTimer(120);
        }
        if (res?.data?.error?.message || res.message) {
          notification.error({
            description: res?.data?.error?.message || res.message,
            duration: 5,
            placement: "top",
          });
        }
      } else {
        message.destroy();
        message.error("Internal Server Error", 2);
      }
    });
  };

  return (
    <>
      <div className="loginpage-background">
        <div className="white-box-content">
          <Row>
            <Col lg={12} xs={12} md={12} sm={12} className="inner-content">
              <Col md={12}>
                <div className="content-box">
                  <img className="imge-logoin-log" src={Hande} alt="" />
                  <h3 className="content-box-h2">
                    Quick and Hassle-Free Online Partner Platform
                  </h3>
                  <p>
                    Now become an Avanse Financial Services Partner in few
                    simple steps. Avanse Partner Portal makes the onboarding
                    process seamless.
                  </p>
                </div>
              </Col>
            </Col>
          </Row>
        </div>

        {(emailIdOption || mobileNumberOption) && (
          <div className="form-contnet">
            <Form
              autoComplete="off"
              name="LoginDetails"
              layout="vertical"
              form={form}
              onFinish={handleCheckIsFirstTimeLogin}
            >
              <Row>
                <Col lg={12} xs={12} md={12} sm={12}>
                  <Col md={12} className="headre-login">
                    <LoginPageHeading LoginHeading="Proceed to Login" />
                  </Col>
                </Col>
              </Row>
              <Row className="mt-2">
                <Col md={6} className="login-check-box">
                  <FormItem
                    name="ViaEmailID"
                    colon={false}
                    rules={[
                      {
                        required: false,
                        message: "Please Select",
                      },
                    ]}
                  >
                    <Checkbox
                      defaultChecked
                      checked={emailIdOption}
                      onClick={() => {
                        handleCheckBox();
                      }}
                    >
                      Via Email ID
                    </Checkbox>
                  </FormItem>
                </Col>
                <Col md={6} className="login-check-box">
                  <FormItem
                    name="ViaMobileID"
                    colon={false}
                    rules={[
                      {
                        required: false,
                        message: "Please Select",
                      },
                    ]}
                  >
                    <Checkbox
                      onClick={() => {
                        handleCheckBox();
                      }}
                      checked={mobileNumberOption}
                    >
                      Via Mobile No
                    </Checkbox>
                  </FormItem>
                </Col>
              </Row>
              <p className="headre-login">
                Enter the{" "}
                {mobileNumberOption ? "Mobile Number" : "email address"}{" "}
                provided during the time of registration on the Partner Portal
              </p>

              <Row>
                <Col md={12}>
                  {emailIdOption ? (
                    <TextInput
                      title="Enter Email ID / Login ID"
                      type="text"
                      name="email"
                      value={state.email?.trim()}
                      maxLength={50}
                      validation={[
                        {
                          required: emailIdOption,
                          message: "Email ID  / Login ID Required!",
                        },
                        // {
                        //   pattern: /^[^\s]+$/,
                        //   message: "Spaces are not allowed!",
                        // },
                      ]}
                      placeholder="Enter Email ID / Login ID"
                      onChange={onChangeTextHandler}
                    />
                  ) : (
                    <TextInput
                      title="Enter Mobile No"
                      type="tel"
                      name="mobileNo"
                      value={state.mobileNo?.trim()}
                      maxLength={10}
                      validation={[
                        {
                          required: mobileNumberOption,
                          message: "Mobile No Required!",
                        },

                        {
                          pattern: new RegExp("^[6-9][0-9]{9}$"),
                          message: "Invalid Mobile No!",
                        },
                      ]}
                      placeholder="Enter Mobile No"
                      onChange={onChangeTextHandler}
                      onInput={(e) => {
                        if (e.target.value.trim() == "") {
                          e.target.value = e.target.value.trim();
                        }

                        if (e.target.value.trim() !== "") {
                          e.target.value = new RegExp("^[0-9-+]*$").test(
                            e.target.value
                          )
                            ? e.target.value?.trimStart()
                            : e.target.value
                                ?.trimStart()
                                ?.substring(0, e.target.value.length - 1);
                        }
                      }}
                    />
                  )}
                </Col>
              </Row>

              {showForgotPassword && (
                <div className="txt-otp">
                  <p className="need-opt">
                    <span className="need-link" onClick={handleForgotPassword}>
                      Forgot Password
                    </span>{" "}
                  </p>
                </div>
              )}

              <Row className="mt-4">
                <Col md={12} className="login-btn mt-4">
                  <UiButton
                    type="submit"
                    title="SUBMIT"
                    disabled={btnDisable}
                  />
                </Col>

                {/* <p className="need-opt text-center mt-2">
                  Need Help? <span className="need-link">Click Here</span>
                </p> */}
              </Row>
            </Form>
          </div>
        )}

        {otpVerifiedScreen && (
          <div className="form-contnet">
            <Form
              autoComplete="off"
              name="LoginDetails"
              layout="vertical"
              form={form}
              onFinish={handleOtpVerification}
            >
              <Row>
                <Col lg={12} xs={12} md={12} sm={12}>
                  <Col md={12} className="headre-login">
                    <LoginPageHeading LoginHeading="Verify OTP" />
                  </Col>
                </Col>
              </Row>
              <Row>
                <p>
                  Please enter OTP sent on registered
                  {maskedUserEmail && ` email ID (${maskedUserEmail}) `}
                  {maskedUserEmail && maskedUserMobile && ` and`}
                  {maskedUserMobile && ` mobile number (${maskedUserMobile}) `}
                  to proceed.
                </p>
              </Row>

              <Row>
                <Col md={12} className="input-text">
                  <br></br>
                  <br></br>
                  <TextInput
                    title={emailIdOption ? "Enter OTP" : "Enter OTP"}
                    type="number"
                    name="otp"
                    value={state.otp}
                    validation={[
                      {
                        required: true,
                        message: "OTP Required!",
                      },
                      // otp should be 4 digit
                      {
                        pattern: new RegExp("^[0-9]{4}$"),
                        message: "Invalid OTP!",
                      },
                    ]}
                    maxLength={4}
                    placeholder="Enter OTP"
                    onChange={onChangeTextHandler}
                    onInput={(e) => {
                      if (e.target.value.trim() == "") {
                        e.target.value = e.target.value.trim();
                      }

                      if (e.target.value.trim() !== "") {
                        e.target.value = new RegExp("^[0-9-+]*$").test(
                          e.target.value
                        )
                          ? e.target.value?.trimStart()
                          : e.target.value
                              ?.trimStart()
                              ?.substring(0, e.target.value.length - 1);
                      }
                    }}
                  />
                  <div className="txt-otp">
                    <p className="need-opt">
                      {moment
                        .utc(moment.duration(timer, "seconds").asMilliseconds())
                        .format("mm:ss")}

                      <Button
                        className="need-link"
                        onClick={handleResendOtp}
                        disabled={timer && timer > 0 && timer}
                        type="link"
                      >
                        RESEND OTP
                      </Button>
                    </p>
                  </div>
                </Col>
              </Row>

              <Row className="">
                <Col md={12} className="login-btn">
                  <UiButton type="submit" title="SUBMIT" />
                </Col>

                {/* <p className="need-opt text-center mt-2">
                  Need Help? <span className="need-link">Click Here</span>
                </p> */}
                <p
                  className="need-opt text-center mt-2"
                  onClick={handleBackToLoginScreen}
                >
                  <img src={BackArrow} alt="" className="backArrowGreenIcon" />
                  <span className="need-link">Back to login screen</span>
                </p>
              </Row>
            </Form>
          </div>
        )}

        {NewPasswordScreen && (
          <div className="form-contnet">
            <Form
              autoComplete="off"
              name="LoginDetails"
              layout="vertical"
              form={form}
              onFinish={handleSetNewPasswordSubmit}
            >
              <Row>
                <Col lg={12} xs={12} md={12} sm={12}>
                  <Col md={12} className="headre-login">
                    <LoginPageHeading LoginHeading="Set New Password" />
                  </Col>
                </Col>
              </Row>
              <Row>
                <p className="mt-3">
                  Your OTP has Been verified successuly! Please set a password
                  for your next Login.
                </p>
              </Row>

              <Row>
                <Col md={12} className="password-input-field">
                  <TextInput
                    title="New Password"
                    type="password"
                    name="password"
                    value={state.password}
                    maxLength={20}
                    // minLength={8}
                    onFocus={() => setIsPasswordFocused(true)}
                    onBlur={() => setIsPasswordFocused(false)}
                    validation={[
                      {
                        required: true,
                        message: "Passwords cannot be empty",
                      },

                      // mimimum 8 characters, at least one uppercase letter, one lowercase letter, one number and one special character with no white spaces

                      {
                        pattern:
                          /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/,
                        message: mobile
                          ? "Password must be at least 8 characters long and contain at least one uppercase letter, one lowercase letter, one number and one special character"
                          : "",
                      },
                      // not include white space
                      {
                        pattern: new RegExp("^(?!.*\\s).*$"),
                        message: "",
                      },
                    ]}
                    placeholder="Enter Password"
                    onChange={onChangeTextHandler}
                  />
                  {!mobile &&
                    (isPasswordFocused ||
                      form
                        .getFieldsError(["password"])
                        .filter(({ errors }) => errors.length).length > 0) && (
                      <div className="error-popup">
                        <div className="error-icon">
                          {new RegExp("^(?!.*\\s).*$").test(state.password) ? (
                            <img
                              src={verfiedGreenIcon}
                              alt="success"
                              className="password-icon"
                            />
                          ) : (
                            <img
                              src={verfiedGrayIcon}
                              alt="error"
                              className="password-icon"
                            />
                          )}

                          <p
                            className={
                              new RegExp("^(?!.*\\s).*$").test(state.password)
                                ? "error-text-green"
                                : "error-text-gray"
                            }
                          >
                            Password must not contain white spaces
                          </p>
                        </div>
                        <div className="error-icon">
                          {state?.password?.length >= 8 ? (
                            <img
                              src={verfiedGreenIcon}
                              alt="success"
                              className="password-icon"
                            />
                          ) : (
                            <img
                              src={verfiedGrayIcon}
                              alt="error"
                              className="password-icon"
                            />
                          )}

                          <p
                            className={
                              state?.password?.length >= 8
                                ? "error-text-green"
                                : "error-text-gray"
                            }
                          >
                            Password must be minimum 8 characters
                          </p>
                        </div>

                        <div className="error-icon">
                          {state?.password?.match(/[a-z]/) ? (
                            <img
                              src={verfiedGreenIcon}
                              alt="success"
                              className="password-icon"
                            />
                          ) : (
                            <img
                              src={verfiedGrayIcon}
                              alt="error"
                              className="password-icon"
                            />
                          )}

                          <p
                            className={
                              state.password?.match(/[a-z]/)
                                ? "error-text-green"
                                : "error-text-gray"
                            }
                          >
                            Atleast one lower case letter
                          </p>
                        </div>
                        <div className="error-icon">
                          {state?.password?.match(/[A-Z]/) ? (
                            <img
                              src={verfiedGreenIcon}
                              alt="success"
                              className="password-icon"
                            />
                          ) : (
                            <img
                              src={verfiedGrayIcon}
                              alt="error"
                              className="password-icon"
                            />
                          )}

                          <p
                            className={
                              state.password?.match(/[A-Z]/)
                                ? "error-text-green"
                                : "error-text-gray"
                            }
                          >
                            Atleast one upper case letter
                          </p>
                        </div>
                        <div className="error-icon">
                          {state.password?.match(/[0-9]/) ? (
                            <img
                              src={verfiedGreenIcon}
                              alt="success"
                              className="password-icon"
                            />
                          ) : (
                            <img
                              src={verfiedGrayIcon}
                              alt="error"
                              className="password-icon"
                            />
                          )}

                          <p
                            className={
                              state.password?.match(/[0-9]/)
                                ? "error-text-green"
                                : "error-text-gray"
                            }
                          >
                            Atleast one number
                          </p>
                        </div>
                        <div className="error-icon">
                          {state.password?.match(/[$@#&!]/) ? (
                            <img
                              src={verfiedGreenIcon}
                              alt="success"
                              className="password-icon"
                            />
                          ) : (
                            <img
                              src={verfiedGrayIcon}
                              alt="error"
                              className="password-icon"
                            />
                          )}

                          <p
                            className={
                              state.password?.match(/[$@#&!]/)
                                ? "error-text-green"
                                : "error-text-gray"
                            }
                          >
                            Atleast one special character
                          </p>
                        </div>
                      </div>
                    )}
                </Col>
                <Col md={12}>
                  <TextInput
                    className="confirm-sec-filed"
                    title="Confirm Password"
                    type="password"
                    name="confirm"
                    value={state.confirm}
                    dependencies={["password"]}
                    hasFeedback
                    validation={[
                      {
                        required: true,
                        message: "Please confirm your password!",
                      },
                      ({ getFieldValue }) => ({
                        validator(_, value) {
                          if (!value || getFieldValue("password") === value) {
                            return Promise.resolve();
                          }
                          return Promise.reject(
                            new Error("Passwords does not match!")
                          );
                        },
                      }),
                    ]}
                    placeholder="Enter Confirm Password"
                    onChange={onChangeTextHandler}
                  />
                </Col>
              </Row>

              <Row>
                <Col md={12} className="login-btn">
                  {state.password &&
                    state.confirm &&
                    new RegExp("^(?!.*\\s).*$").test(state.password) &&
                    state.password.length >= 8 &&
                    state.password.match(/[a-z]/) &&
                    state.password.match(/[A-Z]/) &&
                    state.password.match(/[0-9]/) &&
                    state.password.match(/[$@#&!]/) &&
                    state.password === state.confirm && (
                      <div className="password-match">
                        <img
                          src={passwordMatchIcon}
                          alt="success"
                          className="password-icon"
                        />
                        <p className="text-green">Password Match!!</p>
                      </div>
                    )}
                </Col>
              </Row>
              <Row className="">
                <Col md={12} className="login-btn">
                  <UiButton
                    type="submit"
                    title="SUBMIT"
                    disabled={btnDisable}
                  />
                </Col>

                {/* <p className="need-opt text-center mt-1">
                  Need Help? <span className="need-link">Click Here</span>
                </p> */}
              </Row>
            </Form>
          </div>
        )}

        {passwordScreen && (
          <div className="form-contnet">
            <Form
              autoComplete="off"
              name="LoginDetails"
              layout="vertical"
              form={form}
              onFinish={handleLogin}
            >
              <Row>
                <Col lg={12} xs={12} md={12} sm={12}>
                  <Col md={12} className="headre-login">
                    <LoginPageHeading LoginHeading="Enter your Password" />
                  </Col>
                </Col>
              </Row>
              <Row>
                <p className="mt-3">
                  Enter the Password you had set earlier for the{" "}
                  {loginWith === "MOBILE_NUMBER"
                    ? "mobile number"
                    : "email address"}{" "}
                  {maskedUsername}
                </p>
              </Row>

              <Row>
                <Col md={12} className="input-text">
                  <br></br>
                  <br></br>
                  <TextInput
                    title={"Enter Password"}
                    onInput={(e) => {
                      e.target.value = e.target.value.trim();
                    }}
                    style={{
                      borderRadious: "10px",
                    }}
                    type="password"
                    name="password"
                    value={state.password}
                    validation={[
                      {
                        required: true,
                        message: "Password Required!",
                      },
                    ]}
                    placeholder="Please Enter Password"
                    onChange={onChangeTextHandler}
                  />
                  <div className="txt-otp">
                    <p className="need-opt">
                      <span
                        className="need-link"
                        onClick={handleForgotPassword}
                      >
                        Forgot Password
                      </span>{" "}
                    </p>
                  </div>
                </Col>
              </Row>

              <Row className="">
                <Col md={12} className="login-btn">
                  <UiButton
                    type="submit"
                    title="SUBMIT"
                    disabled={btnDisable}
                  />
                </Col>

                {/* <p className="need-opt text-center mt-2">
                  Need Help? <span className="need-link">Click Here</span>
                </p> */}
                <p
                  className="need-opt text-center mt-2"
                  onClick={handleBackToLoginScreen}
                >
                  <img src={BackArrow} alt="" className="backArrowGreenIcon" />
                  <span className="need-link">Back to login screen</span>
                </p>
              </Row>
            </Form>
          </div>
        )}
        <Modal
          open={isAlreadyLoggin}
          closable={false}
          className="modal-container"
          centered
          footer={null}
        >
          {" "}
          <Form
            autoComplete="off"
            name="logout"
            className="change-password"
            form={form}
          >
            <Row className="mt-2">
              <Col lg={12} xs={12} md={12} sm={12}>
                <div style={{ textAlign: "center" }}>
                  <span>
                    You are already logged in into other device,
                    <br />
                    Do you wish to continue?
                  </span>{" "}
                </div>
              </Col>
            </Row>

            <Row className="mt-4">
              <hr />
              <Col md={12} className="d-flex justify-content-end mt-2">
                <Button
                  className="mr-3"
                  htmlType="button"
                  type="default"
                  onClick={isAlreadyLogginHandlerCancel}
                >
                  No
                </Button>
                <Button
                  className=""
                  htmlType="button"
                  type="primary"
                  onClick={isAlreadyLogginHandlerOk}
                >
                  Yes
                </Button>
              </Col>
            </Row>
          </Form>
        </Modal>
      </div>
    </>
  );
};
const mapDispatchToProps = (dispatch) => {
  return {
    isFirstTimeLogin: (user) => dispatch(isFirstTimeLogin(user)),
    userLogin: (user) => dispatch(login(user)),
    isForgotPassword: (user) => dispatch(isForgotPassword(user)),
    resendOtp: (user) => dispatch(resendOtp(user)),
    verifyOtp: (user) => dispatch(verifyOtp(user)),
    setNewPassword: (user) => dispatch(setNewPassword(user)),
    optLogin: (data) => dispatch(optLogin(data)),
    resendLoginOTP: (data) => dispatch(resendLoginOTP(data)),
  };
};

const mapStateToProps = (state) => {
  return {
    auth: state.auth,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(NewUserLogin);
